import { useDeviceLocation } from 'app/agriculture/queries/devices/useDeviceLocation';
import { FlyToButton } from 'app/agriculture/components/FlyToButton/FlyToButton';

export function DeviceFlyToButton({ deviceId }: { deviceId: string }) {
    const location = useDeviceLocation({ deviceId });
    if (location == null) return null;
    return <FlyToButton position={location} />;
}
